import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext.jsx";
import { ToastProvider } from "./context/ToastContext.jsx";
import HomePage from "./pages/HomePage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import { readPortalSession } from "./utils/portalSession.js";

function RequirePortalSession({ children }) {
  if (!readPortalSession()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <LanguageProvider>
      <ToastProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequirePortalSession>
                <HomePage />
              </RequirePortalSession>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </ToastProvider>
    </LanguageProvider>
  );
}

export default App;
